import { lazy } from 'react'

// ** Document title
const TemplateTitle = 'Wetu'

// ** Default Route
const DefaultRoute = '/Login'

// ** Merge Routes
const Routes = [
  {
    path: '/forgotPassword',
    component: lazy(() => import('@src/views/pages/ForgotPassword')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      publicRoute: true,
      resource: 'forgotPassword'
    }
  },
  {
    path: '/login',
    component: lazy(() => import('@src/views/pages/Login')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      authRoute: true,
      publicRoute: true,
      resource: 'login'
    }
  },
  {
    path: '/register',
    component: lazy(() => import('@src/views/pages/Registration')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      publicRoute: true,
      resource: 'register'
    }
  },
  {
    path: '/serverError',
    component: lazy(() => import('@src/views/pages/ServerError')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      publicRoute: true,
      resource: 'serverError'
    }
  },
  {
    path: '/updateAccount',
    component: lazy(() => import('@src/views/pages/UpdateAccount')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      resource: 'updateAccount'
    }
  },
  {
    path: '/updatedAccount',
    component: lazy(() => import('@src/views/pages/UpdatedAccount')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      resource: 'updatedAccount'
    }
  },
  {
    path: '/updatePassword/:resetPasswordTokenId',
    component: lazy(() => import('@src/views/pages/ResetPassword')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      publicRoute: true,
      resource: 'updatePassword'
    }
  },
  {
    path: '/verify',
    component: lazy(() => import('@src/views/pages/Verification')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      publicRoute: true,
      resource: 'verify'
    }
  },
  {
    path: '/verifying/:userVerificationTokenId',
    component: lazy(() => import('@src/views/pages/Verifying')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      publicRoute: true,
      resource: 'verifying'
    }
  }
]

export { DefaultRoute, TemplateTitle, Routes }
